"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class OrganizationApi extends runtime.BaseAPI {
    /**
     * This method adds an organization to a service desk. If the organization ID is already associated with the service desk, no change is made and the resource returns a 204 success code.  **[Permissions](#permissions) required**: Service desk\'s agent.
     * Add organization
     */
    addOrganizationRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['serviceDeskId'] == null) {
                throw new runtime.RequiredError('serviceDeskId', 'Required parameter "serviceDeskId" was null or undefined when calling addOrganization().');
            }
            if (requestParameters['organizationServiceDeskUpdateDTO'] == null) {
                throw new runtime.RequiredError('organizationServiceDeskUpdateDTO', 'Required parameter "organizationServiceDeskUpdateDTO" was null or undefined when calling addOrganization().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/servicedesk/{serviceDeskId}/organization`.replace(`{${"serviceDeskId"}}`, encodeURIComponent(String(requestParameters['serviceDeskId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.OrganizationServiceDeskUpdateDTOToJSON)(requestParameters['organizationServiceDeskUpdateDTO']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This method adds an organization to a service desk. If the organization ID is already associated with the service desk, no change is made and the resource returns a 204 success code.  **[Permissions](#permissions) required**: Service desk\'s agent.
     * Add organization
     */
    addOrganization(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.addOrganizationRaw(requestParameters, initOverrides);
        });
    }
    /**
     * This method adds users to an organization.  **[Permissions](#permissions) required**: Service desk administrator or agent. Note: Permission to add users to an organization can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Add users to organization
     */
    addUsersToOrganizationRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationId'] == null) {
                throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling addUsersToOrganization().');
            }
            if (requestParameters['usersOrganizationUpdateDTO'] == null) {
                throw new runtime.RequiredError('usersOrganizationUpdateDTO', 'Required parameter "usersOrganizationUpdateDTO" was null or undefined when calling addUsersToOrganization().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization/{organizationId}/user`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.UsersOrganizationUpdateDTOToJSON)(requestParameters['usersOrganizationUpdateDTO']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This method adds users to an organization.  **[Permissions](#permissions) required**: Service desk administrator or agent. Note: Permission to add users to an organization can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Add users to organization
     */
    addUsersToOrganization(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.addUsersToOrganizationRaw(requestParameters, initOverrides);
        });
    }
    /**
     * This method creates an organization by passing the name of the organization.  **[Permissions](#permissions) required**: Service desk administrator or agent. Note: Permission to create organizations can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Create organization
     */
    createOrganizationRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationCreateDTO'] == null) {
                throw new runtime.RequiredError('organizationCreateDTO', 'Required parameter "organizationCreateDTO" was null or undefined when calling createOrganization().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.OrganizationCreateDTOToJSON)(requestParameters['organizationCreateDTO']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrganizationDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method creates an organization by passing the name of the organization.  **[Permissions](#permissions) required**: Service desk administrator or agent. Note: Permission to create organizations can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Create organization
     */
    createOrganization(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.createOrganizationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method deletes an organization. Note that the organization is deleted regardless of other associations it may have. For example, associations with service desks.  **[Permissions](#permissions) required**: Jira administrator.
     * Delete organization
     */
    deleteOrganizationRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationId'] == null) {
                throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling deleteOrganization().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization/{organizationId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This method deletes an organization. Note that the organization is deleted regardless of other associations it may have. For example, associations with service desks.  **[Permissions](#permissions) required**: Jira administrator.
     * Delete organization
     */
    deleteOrganization(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.deleteOrganizationRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Removes an organization property. Organization properties are a type of entity property which are available to the API only, and not shown in Jira Service Management. [Learn more](https://developer.atlassian.com/cloud/jira/platform/jira-entity-properties/).  For operations relating to organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Service Desk Administrator or Agent.  Note: Permission to manage organizations can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Delete property
     */
    deletePropertyRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationId'] == null) {
                throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling deleteProperty().');
            }
            if (requestParameters['propertyKey'] == null) {
                throw new runtime.RequiredError('propertyKey', 'Required parameter "propertyKey" was null or undefined when calling deleteProperty().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization/{organizationId}/property/{propertyKey}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"propertyKey"}}`, encodeURIComponent(String(requestParameters['propertyKey']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Removes an organization property. Organization properties are a type of entity property which are available to the API only, and not shown in Jira Service Management. [Learn more](https://developer.atlassian.com/cloud/jira/platform/jira-entity-properties/).  For operations relating to organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Service Desk Administrator or Agent.  Note: Permission to manage organizations can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Delete property
     */
    deleteProperty(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.deletePropertyRaw(requestParameters, initOverrides);
        });
    }
    /**
     * This method returns details of an organization. Use this method to get organization details whenever your application component is passed an organization ID but needs to display other organization details.  To get organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Any  **Response limitations**: Customers can only retrieve organization of which they are members.
     * Get organization
     */
    getOrganizationRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationId'] == null) {
                throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getOrganization().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization/{organizationId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrganizationDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns details of an organization. Use this method to get organization details whenever your application component is passed an organization ID but needs to display other organization details.  To get organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Any  **Response limitations**: Customers can only retrieve organization of which they are members.
     * Get organization
     */
    getOrganization(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns a list of organizations in the Jira Service Management instance. Use this method when you want to present a list of organizations or want to locate an organization by name.  **[Permissions](#permissions) required**: Any. However, to fetch organizations based on `accountId` the user must have a Service Desk agent license.  **Response limitations**: If the user is a customer, only those organizations of which the customer is a member are listed.
     * Get organizations
     */
    getOrganizationsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            if (requestParameters['accountId'] != null) {
                queryParameters['accountId'] = requestParameters['accountId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOOrganizationDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns a list of organizations in the Jira Service Management instance. Use this method when you want to present a list of organizations or want to locate an organization by name.  **[Permissions](#permissions) required**: Any. However, to fetch organizations based on `accountId` the user must have a Service Desk agent license.  **Response limitations**: If the user is a customer, only those organizations of which the customer is a member are listed.
     * Get organizations
     */
    getOrganizations(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns a list of all organizations associated with a service desk.  **[Permissions](#permissions) required**: Service desk\'s agent.
     * Get organizations
     */
    getOrganizations_1Raw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['serviceDeskId'] == null) {
                throw new runtime.RequiredError('serviceDeskId', 'Required parameter "serviceDeskId" was null or undefined when calling getOrganizations_1().');
            }
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            if (requestParameters['accountId'] != null) {
                queryParameters['accountId'] = requestParameters['accountId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/servicedesk/{serviceDeskId}/organization`.replace(`{${"serviceDeskId"}}`, encodeURIComponent(String(requestParameters['serviceDeskId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOOrganizationDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns a list of all organizations associated with a service desk.  **[Permissions](#permissions) required**: Service desk\'s agent.
     * Get organizations
     */
    getOrganizations_1(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizations_1Raw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns the keys of all organization properties. Organization properties are a type of entity property which are available to the API only, and not shown in Jira Service Management. [Learn more](https://developer.atlassian.com/cloud/jira/platform/jira-entity-properties/).  To get organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Any  **Response limitations**: Customers can only access properties of organizations of which they are members.
     * Get properties keys
     */
    getPropertiesKeysRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationId'] == null) {
                throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getPropertiesKeys().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization/{organizationId}/property`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PropertyKeysFromJSON)(jsonValue));
        });
    }
    /**
     * Returns the keys of all organization properties. Organization properties are a type of entity property which are available to the API only, and not shown in Jira Service Management. [Learn more](https://developer.atlassian.com/cloud/jira/platform/jira-entity-properties/).  To get organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Any  **Response limitations**: Customers can only access properties of organizations of which they are members.
     * Get properties keys
     */
    getPropertiesKeys(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPropertiesKeysRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns the value of an organization property. Use this method to obtain the JSON content for an organization\'s property. Organization properties are a type of entity property which are available to the API only, and not shown in Jira Service Management. [Learn more](https://developer.atlassian.com/cloud/jira/platform/jira-entity-properties/).  To get organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Any  **Response limitations**: Customers can only access properties of organizations of which they are members.
     * Get property
     */
    getPropertyRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationId'] == null) {
                throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getProperty().');
            }
            if (requestParameters['propertyKey'] == null) {
                throw new runtime.RequiredError('propertyKey', 'Required parameter "propertyKey" was null or undefined when calling getProperty().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization/{organizationId}/property/{propertyKey}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"propertyKey"}}`, encodeURIComponent(String(requestParameters['propertyKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.EntityPropertyFromJSON)(jsonValue));
        });
    }
    /**
     * Returns the value of an organization property. Use this method to obtain the JSON content for an organization\'s property. Organization properties are a type of entity property which are available to the API only, and not shown in Jira Service Management. [Learn more](https://developer.atlassian.com/cloud/jira/platform/jira-entity-properties/).  To get organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Any  **Response limitations**: Customers can only access properties of organizations of which they are members.
     * Get property
     */
    getProperty(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPropertyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns all the users associated with an organization. Use this method where you want to provide a list of users for an organization or determine if a user is associated with an organization.  **[Permissions](#permissions) required**: Service desk administrator or agent.
     * Get users in organization
     */
    getUsersInOrganizationRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationId'] == null) {
                throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getUsersInOrganization().');
            }
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization/{organizationId}/user`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOUserDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns all the users associated with an organization. Use this method where you want to provide a list of users for an organization or determine if a user is associated with an organization.  **[Permissions](#permissions) required**: Service desk administrator or agent.
     * Get users in organization
     */
    getUsersInOrganization(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUsersInOrganizationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method removes an organization from a service desk. If the organization ID does not match an organization associated with the service desk, no change is made and the resource returns a 204 success code.  **[Permissions](#permissions) required**: Service desk\'s agent.
     * Remove organization
     */
    removeOrganizationRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['serviceDeskId'] == null) {
                throw new runtime.RequiredError('serviceDeskId', 'Required parameter "serviceDeskId" was null or undefined when calling removeOrganization().');
            }
            if (requestParameters['organizationServiceDeskUpdateDTO'] == null) {
                throw new runtime.RequiredError('organizationServiceDeskUpdateDTO', 'Required parameter "organizationServiceDeskUpdateDTO" was null or undefined when calling removeOrganization().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/servicedesk/{serviceDeskId}/organization`.replace(`{${"serviceDeskId"}}`, encodeURIComponent(String(requestParameters['serviceDeskId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.OrganizationServiceDeskUpdateDTOToJSON)(requestParameters['organizationServiceDeskUpdateDTO']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This method removes an organization from a service desk. If the organization ID does not match an organization associated with the service desk, no change is made and the resource returns a 204 success code.  **[Permissions](#permissions) required**: Service desk\'s agent.
     * Remove organization
     */
    removeOrganization(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.removeOrganizationRaw(requestParameters, initOverrides);
        });
    }
    /**
     * This method removes users from an organization.  **[Permissions](#permissions) required**: Service desk administrator or agent. Note: Permission to delete users from an organization can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Remove users from organization
     */
    removeUsersFromOrganizationRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationId'] == null) {
                throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling removeUsersFromOrganization().');
            }
            if (requestParameters['usersOrganizationUpdateDTO'] == null) {
                throw new runtime.RequiredError('usersOrganizationUpdateDTO', 'Required parameter "usersOrganizationUpdateDTO" was null or undefined when calling removeUsersFromOrganization().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization/{organizationId}/user`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.UsersOrganizationUpdateDTOToJSON)(requestParameters['usersOrganizationUpdateDTO']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This method removes users from an organization.  **[Permissions](#permissions) required**: Service desk administrator or agent. Note: Permission to delete users from an organization can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Remove users from organization
     */
    removeUsersFromOrganization(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.removeUsersFromOrganizationRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Sets the value of an organization property. Use this resource to store custom data against an organization. Organization properties are a type of entity property which are available to the API only, and not shown in Jira Service Management. [Learn more](https://developer.atlassian.com/cloud/jira/platform/jira-entity-properties/).  To store organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Service Desk Administrator or Agent.  Note: Permission to manage organizations can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Set property
     */
    setPropertyRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organizationId'] == null) {
                throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling setProperty().');
            }
            if (requestParameters['propertyKey'] == null) {
                throw new runtime.RequiredError('propertyKey', 'Required parameter "propertyKey" was null or undefined when calling setProperty().');
            }
            if (requestParameters['body'] == null) {
                throw new runtime.RequiredError('body', 'Required parameter "body" was null or undefined when calling setProperty().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/organization/{organizationId}/property/{propertyKey}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"propertyKey"}}`, encodeURIComponent(String(requestParameters['propertyKey']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['body'],
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Sets the value of an organization property. Use this resource to store custom data against an organization. Organization properties are a type of entity property which are available to the API only, and not shown in Jira Service Management. [Learn more](https://developer.atlassian.com/cloud/jira/platform/jira-entity-properties/).  To store organization detail field values which are visible in Jira Service Management, see the [Customer Service Management REST API](https://developer.atlassian.com/cloud/customer-service-management/rest/v1/api-group-organization/#api-group-organization).  **[Permissions](#permissions) required**: Service Desk Administrator or Agent.  Note: Permission to manage organizations can be switched to users with the Jira administrator permission, using the **[Organization management](https://confluence.atlassian.com/servicedeskcloud/setting-up-service-desk-users-732528877.html#Settingupservicedeskusers-manageorgsManageorganizations)** feature.
     * Set property
     */
    setProperty(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.setPropertyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.OrganizationApi = OrganizationApi;
//# sourceMappingURL=OrganizationApi.js.map